<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
    navActiveLink: 'subjects',
  },
})

import { useScheduleStore } from "@/utils/stores/schedule"
import Answer from "@/views/subjectsV2/crf-answer/answer.vue"
import SelectAnswer from "@/views/subjectsV2/crf-answer/selectAnswer.vue"
import ConfirmReason from "@/views/build/common/confirmReason.vue"
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const refAnswer = ref(null)

/** 이 페이지만 사용: 수정 사유 5개 + 미선택 기본 */
const ANSWER_REASON_OPTIONS = [
  { label: '오기록 수정', value: 0 },
  { label: '기록 추가', value: 1 },
  { label: '기타 (입력)', value: 2 },
]

const onEditConfirm = payload => refAnswer.value?.editConfirm?.(payload)

const route = useRoute()
const router = useRouter()

const { data: subjectData } = await useApi(createUrl(`/subjects/${route.params.subject}`))
const isReadonly = computed(() => !!subjectData.value?.deleted)

const groupId = ref("0")
const cycleId = ref("0")
const visitId = ref("0")
const scheduleId = ref("0")
const nextScheduleId = ref("0")
const answerList = ref([]) // ★ 추가: 교차 스케줄 복사용 리스트
const cycleVisitList = ref([]) // ★ 추가: visit ID 정규화용

// 초기 scheduleId 동기화
scheduleId.value = String(route.params.schedule || "0")

/**
 * SelectAnswer(좌측 패널)에서 올라온 선택 결과를 수신
 * @param {Object} s          스케줄 객체( gId, cId, vId 포함 )
 * @param {string} sId        현재 스케줄 id
 * @param {string} nsId       다음 스케줄 id
 * @param {number} status     상태
 * @param {Array}  aList      ★ answerList (교차 참조용)
 */
const onSelectedAnswer = (s, sId, nsId, status, aList, cvList) => {
  groupId.value       = String(s.gId ?? "0")
  cycleId.value       = String(s.cId ?? "0")
  visitId.value       = String(s.vId ?? "0")
  scheduleId.value    = String(sId ?? "0")
  nextScheduleId.value= String(nsId ?? "0")

  answerList.value    = Array.isArray(aList) ? aList : []  // ★ 저장
  cycleVisitList.value = Array.isArray(cvList) ? cvList : [] // ★ 저장

  useScheduleStore().setScheduleStatus(router.currentRoute.value.params.subject, status)
}

const refSelectAnswer = ref()

// Answer에서 저장이 일어나면 좌측 패널 데이터 갱신
const saveAnswer = () => {
  refSelectAnswer.value?.fetchDatas?.()
}

// Answer에서 다음 스케줄로 이동 요청 시
const onNext = () => {
  // 내부적으로 nextScheduleId는 SelectAnswer가 다시 계산합니다.
  scheduleId.value = String(nextScheduleId.value || "0")
  refSelectAnswer.value?.fetchDatas?.()
}
</script>

<template>
  <VAlert
    v-if="isReadonly"
    type="info"
    variant="tonal"
    class="mb-4"
  >
    중도탈락된 검체입니다. 읽기 전용 모드로 표시됩니다.
  </VAlert>
  <ConfirmReason
    v-if="!isReadonly"
    :reason-options="ANSWER_REASON_OPTIONS"
    :default-reason="null"
    @confirm="onEditConfirm"
  />
  <VRow>
    <!-- 좌측 스케줄/그룹 선택 패널 -->
    <VCol
      cols="12"
      md="3"
      style="max-inline-size:400px"
    >
      <SelectAnswer
        ref="refSelectAnswer"
        :schedule-id="scheduleId"
        @select-answer="onSelectedAnswer"
      />
    </VCol>

    <!-- 우측 Answer 화면 -->
    <VCol
      cols="12"
      md="9"
    >
      <!-- 초기 렌더 가드(선택): id들이 준비된 뒤 렌더링 -->
      <Answer
        v-if="groupId && cycleId && visitId && scheduleId"
        ref="refAnswer"
        :group-id="groupId"
        :cycle-id="cycleId"
        :visit-id="visitId"
        :schedule-id="scheduleId"
        :next-schedule-id="nextScheduleId"
        :answer-list="answerList"
        :cycle-visit-list="cycleVisitList"
        :readonly="isReadonly"
        @save-answer="saveAnswer"
        @on-next="onNext"
      /> 
    </VCol>
  </VRow>
</template>
